import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Box,
  Chip,
  CircularProgress,
  Alert
} from '@mui/material';
import { categories } from '../data/dummyData';
import MainService from '../services/MainService';
import config from '../services/config.json';

const Categories = () => {
  const navigate = useNavigate();
  
  // API Data States
  const [apiCategories, setApiCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // API Call Function
  const fetchCategories = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await MainService.CategoriesInDropdown();
      setApiCategories(response);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setError('Failed to load categories');
    } finally {
      setLoading(false);
    }
  };

  // Call API on component mount
  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryId) => {
    navigate(`/products?categoryId=${categoryId}`);
  };

  // Use API data if available, otherwise fallback to dummy data
  const displayCategories = apiCategories.length > 0 ? apiCategories : categories;

  return (
    <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
        Product Categories
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
        Explore our wide range of fresh products
      </Typography>

      {/* Categories Loading */}
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <CircularProgress sx={{ color: '#2E7D32' }} />
        </Box>
      )}

      {/* Categories Error */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={4}>
        {displayCategories.map((category) => (
          <Grid item xs={12} sm={6} md={4} key={category.Id || category.id || Math.random()}>
            <Card
              sx={{
                height: 350,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                },
                position: 'relative',
                overflow: 'hidden',
              }}
              onClick={() => handleCategoryClick(category.Id || category.id)}
            >
              <CardMedia
                component="img"
                height="350"
                image={apiCategories.length > 0 ? config.API_BASE_URL + (category.Icon || category.icon || '') : category.image}
                alt={category.Name || category.name || 'Category'}
                sx={{
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                  color: 'white',
                  p: 3,
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {category.Name || category.name || 'Category Name'}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>
                  {category.Description || category.description || 'Category description'}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Chip
                    label="View Products"
                    sx={{
                      backgroundColor: '#2E7D32',
                      color: 'white',
                      fontWeight: 'bold',
                    }}
                  />
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Fresh & Quality
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      
    </Container>
  );
};

export default Categories; 